module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAADgAAAACYjX/eAAAA70lEQVQ4EWOU6fnj+e/v/1n/Gf7LMFAAGBkZHjMxMaUzSnX+fmwv80cmQu0vAxcLeSZ++8PAsOIWM8PBp8yPmUAui6TAMJATQA4BmfH/P4MsE0iAk0yXgfTCAMwMsIEwQWrQGG7b9YiJ4cxLZgZLyb8MjjL/sNqBTw2KgY8/MzIsuQERuvmehcFQ9DeDAPt/FEMJqcHpZWAyYAAivACbGhQXyvL+Z4jR+AP2sq30PwZ+NNeBTCekBsVAkAY3uX9gDGLjAvjU4PQyLsMIiYMN/A5M6ZQCmBlMjAyMT5YDsw0o+5ALQHpBZoDyMyO1CwcAYoNflmKW4qsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/verifyCode.png
// module id = x/Iy
// module chunks = 3